import clsx from 'clsx';
import { Icon } from '../Icon/Icon';
import { initials } from './initials';
import styles from './Avatar.module.css';

export interface AvatarProps {
  /** Full name; initials are derived from it. Omit for the guest avatar. */
  name?: string;
  size?: number;
  /** Small red dot (unread). */
  dot?: boolean;
  className?: string;
}

/** Round avatar with initials (`.av`), or the guest silhouette. */
export function Avatar({ name, size = 32, dot = false, className }: AvatarProps) {
  const fontSize = size >= 72 ? 24 : size >= 44 ? 15 : size <= 26 ? 9.5 : 12.5;
  return (
    <span
      className={clsx(styles.av, !name && styles.guest, className)}
      style={{ width: size, height: size, fontSize }}
      aria-hidden="true"
    >
      {name ? (
        initials(name)
      ) : (
        <Icon name="user" size={size >= 60 ? 30 : Math.round(size * 0.53)} strokeWidth={size >= 60 ? 1.8 : 2} />
      )}
      {dot && <span className={styles.dot} />}
    </span>
  );
}
